<template>
    <div>
        <div class="u-text-left">
            <button
                v-if="canDownload"
                @click="showModal"
                type="button"
                class="btn btn--link"
            >
                <strong>Download SSL certificaat</strong>
                <img src="../assets/icomoon/SVG/arrow-right-orange.svg" class="u-margin-left-inline" />
            </button>
        </div>

        <ssl-download-modal
            v-if="cancelModalVisible"
            @close="closeModal"
            :subscription="subscription"
        />
    </div>
</template>

<script>
import SslDownloadModal from './SslDownloadModal';
import serviceMixin from '../mixins/service.js';

export default {
    components: {
        SslDownloadModal
    },
    mixins: [serviceMixin],
    props: {
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            cancelModalVisible: false
        };
    },
    computed: {
        /**
         * Checks if the subscription is active.
         *
         * @return {boolean}
         */
        isActive() {
            return this.subscription.administrative_status !== 'deleted';
        },
        /**
         * Checks if the current user can download the certificates
         *
         * @return {boolean}
         */
        canDownload() {
            return this.isActive && this.subscription.certificates && this.subscription.certificates.length !== 0;
        }
    },
    methods: {
        /**
         * Show the modal.
         */
        showModal() {
            this.cancelModalVisible = true;
        },

        /**
         * Close the modal.
         */
        closeModal() {
            this.cancelModalVisible = false;
        }
    }
};
</script>
